var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Preferences } from '@capacitor/preferences';
const setStorage = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
    yield Preferences.set({
        key,
        value: JSON.stringify(value)
    });
});
const getStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const { value } = yield Preferences.get({ key });
    if (!value || value === "undefined")
        return null;
    return JSON.parse(value);
});
const removeStorage = (key) => __awaiter(void 0, void 0, void 0, function* () {
    yield Preferences.remove({ key });
});
const SecureStorage = {
    set: setStorage,
    get: getStorage,
    remove: removeStorage
};
export default SecureStorage;
